import React from 'react';
import { useTranslation } from 'react-i18next';
import { differenceInCalendarDays } from 'date-fns';
import styles from './styles/Banners.module.scss';

import { OmaLummeApp } from '../../../omaLummeContext';

import Button from '../../Common/Button';

// Utils.
import { formatDate } from '../../../utils/billing';
import { getContractDateTo } from '../../../utils/contracts';
import { useWindowSize } from '../../Layout/Header';

const CampaignPriceOfferBanner: React.FunctionComponent = () => {
  const { t } = useTranslation();
  const { offers, selectedMeteringPoint, selectedMeteringPointContract } = OmaLummeApp.useState();

  const offerBannerDisplayedDate = localStorage.getItem('OfferBannerDismissDate');
  const offerBannerDateDiff = offerBannerDisplayedDate ? differenceInCalendarDays(new Date(), new Date(offerBannerDisplayedDate)) : undefined;

  const [showBanner, setShowBanner] = React.useState<boolean>(
    offerBannerDisplayedDate ? offerBannerDateDiff !== undefined && offerBannerDateDiff > 60 : true,
  );

  if (offerBannerDateDiff !== undefined && offerBannerDateDiff > 60) {
    localStorage.removeItem('OfferBannerDismissDate');
  }

  const offer =
    offers && offers.length > 0 && selectedMeteringPoint ? offers.find((o) => o.contractNo === selectedMeteringPoint.contractNo) : undefined;

  const windowWidth = useWindowSize()[0];
  const isMobile = windowWidth < 768;

  return (
    <>
      {offer && offer.offerCtaOnline && selectedMeteringPointContract && showBanner && (
        <>
          <div className={`${styles.greenBanner} ${offer.addOnOffer === true ? styles.limeBanner : styles.lavenderBanner}`}>
            <div>
              <button
                className={styles.dismiss}
                onClick={() => {
                  setShowBanner(false);
                  window.localStorage.setItem('OfferBannerDismissDate', new Date().toISOString());
                }}
              >
                <span>{t(`common:general.close`)}</span>
              </button>
              <h2 className="h1">
                {offer.offerTitleOnline}{' '}
                {offer.renewalOffer === true
                  ? formatDate(new Date(getContractDateTo(selectedMeteringPointContract).dateTo || new Date()).toISOString())
                  : ''}
              </h2>

              <Button
                className={offer.addOnOffer === true ? 'buttonTertiaryLime' : 'buttonTertiaryLavender'}
                link={offer.offerUrl}
                newTab={!isMobile}
              >
                {offer.offerCtaOnline}
              </Button>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default CampaignPriceOfferBanner;
